import { EnglishStr } from "@/lib/EnglishStr";
import ErrorTemplate from "./ErrorTemplate";

export default function GeneralError() {
  return (
    <ErrorTemplate
      title="We're having some difficulty processing your application online"
      content={
        <>
          Based on the information you provided, we are unable to process your
          application online. Please call us at{" "}
          <a href="tel" target="_blank">
            {" "}
            <span className="active underline">
              {EnglishStr.ContactCentrePhone}
            </span>
          </a>{" "}
          or{" "}
          <a href="https://www.meridiancu.ca" target="_blank">
            <span className="active underline">visit a Meridian branch</span>
          </a>{" "}
          to start your application.
        </>
      }
    />
  );
}
